export const manifest = {
  screens: {
    scr_hlnhrq: { name: "Processing Manager — Processor Requests", route: "/", state: {"currentUserId":"u1"}, position: {"x":160,"y":220} },
    scr_6s5rox: { name: "Loan Officer Manager — LO Requests", route: "/", state: {"currentUserId":"u7"}, position: {"x":4360,"y":220} },
    scr_dgui0u: { name: "Processor — My Requests", route: "/", state: {"currentUserId":"u2"}, position: {"x":1560,"y":220} },
    scr_qc7fkd: { name: "Loan Officer — My Requests", route: "/", state: {"currentUserId":"u4"}, position: {"x":2960,"y":220} },
    scr_d84o16: { name: "Manager — Team PTO Dashboard", route: "/", state: {"currentUserId":"u1","view":"dashboard"}, position: {"x":160,"y":2200} },
    scr_rbgnpy: { name: "Processor — My PTO Dashboard", route: "/", state: {"currentUserId":"u2","view":"dashboard"}, position: {"x":1560,"y":2200} },
  },
  sections: {
    sec_7ylk4u: { name: "Request Management Dashboard", x: 0, y: 0, width: 5720, height: 1180 },
    sec_4l26te: { name: "PTO Dashboard", x: 0, y: 1980, width: 2920, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_7ylk4u", children: [
      { kind: "screen", id: "scr_hlnhrq" },
      { kind: "screen", id: "scr_dgui0u" },
      { kind: "screen", id: "scr_qc7fkd" },
      { kind: "screen", id: "scr_6s5rox" },
    ] },
    { kind: "section", id: "sec_4l26te", children: [
      { kind: "screen", id: "scr_d84o16" },
      { kind: "screen", id: "scr_rbgnpy" },
    ] },
  ],
}
